import { render, staticRenderFns } from "./ImportantCheck.vue?vue&type=template&id=37a6759e&scoped=true&lang=pug&"
import script from "./ImportantCheck.vue?vue&type=script&lang=ts&"
export * from "./ImportantCheck.vue?vue&type=script&lang=ts&"
import style0 from "./ImportantCheck.vue?vue&type=style&index=0&id=37a6759e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a6759e",
  null
  
)

export default component.exports